/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ready: NonNullable<unknown> }} Portals_Check_Photos_OkInputs */

const cs_portals_check_photos_ok = /** @type {(inputs: Portals_Check_Photos_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fotografie: v pořádku (${i?.ready})`)
};

const en_portals_check_photos_ok = /** @type {(inputs: Portals_Check_Photos_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Photos: OK (${i?.ready})`)
};

/**
* | output |
* | --- |
* | "Photos: OK ({ready})" |
*
* @param {Portals_Check_Photos_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_photos_ok = /** @type {((inputs: Portals_Check_Photos_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_Photos_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_photos_ok(inputs)
	return cs_portals_check_photos_ok(inputs)
});